/**
 * Created by staffanrantzow on 15/04/16.
 */

import { proxyCounterpart } from '../../scripts/proxyCounterpart';
import { getVatById } from '../../views/invoice-tool/invoice-tool-helper';

export default class SupplierLedgerEntity {

  constructor (
    id,
    amount,
    arrivedDate,
    createdAt,
    expenseId,
    invoiceId,
    invoiceItemId,
    payedDate,
    status,
    supplierInvoiceAccount,
    supplierInvoiceNr,
    supplierInvoiceUt,
    supplierLedgerTypeId,
    supplierName,
    taxId,
    taxPercent,
    typeId,
    userIdAuthorization,
    userIdCreator,
    file
  ) {
    this.id = id;
    this.amount = amount;
    this.arrivedDate = arrivedDate;
    this.createdAt = createdAt;
    this.expenseId = expenseId;
    this.invoiceId = invoiceId;
    this.invoiceItemId = invoiceItemId;
    this.payedDate = payedDate;
    this.status = status;
    this.supplierInvoiceAccount = supplierInvoiceAccount;
    this.supplierInvoiceNr = supplierInvoiceNr;
    this.supplierInvoiceUt = supplierInvoiceUt;
    this.supplierLedgerTypeId = supplierLedgerTypeId;
    this.supplierName = supplierName;
    this.taxId = taxId;
    this.taxPercent = taxPercent;
    this.typeId = typeId;
    this.userIdAuthorization = userIdAuthorization;
    this.userIdCreator = userIdCreator;
    this.file = file;
  }

  get statusText () {
    switch (this.status) {
      case 1:
        return proxyCounterpart('IS_PAID');
      case 2:
        return proxyCounterpart('ONGOING');
      case 3:
        return proxyCounterpart('NEW');
      case 4:
        return proxyCounterpart('WAITING');
      case 5:
        return proxyCounterpart('CREDITED');
      case 6:
        return proxyCounterpart('DISPUTE');
      case 7:
        return proxyCounterpart('INVOICE_NOT_CHECKED');
      case 8:
        return proxyCounterpart('LEVRES');
      case 9:
        return proxyCounterpart('INVOICE_NOT_CREATED');
      case 10:
        return proxyCounterpart('TO_PAYMENT');
      case 11:
        return proxyCounterpart('PAID_FILE');
      case 12:
        return proxyCounterpart('OLD_POST');
    }
  }

  get amountIncVat () {
    return Math.round(this.amount * (1 + (getVatById(this.taxId) / 100)) * 100) / 100;
  }

}



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/supplier-ledgers/supplier-ledger-entity.js
 **/